import { render, staticRenderFns } from "./ContextualMenu.vue?vue&type=template&id=44a786d8"
import script from "./ContextualMenu.vue?vue&type=script&lang=ts"
export * from "./ContextualMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports